import React from "react";

export default function Footer() {
  return (
    <>
      <div className="footer">
        {/* <!--top--> */}

        {/* <!--/top--> */}

        {/* <!--middle--> */}

        <div className="container-fluid middleRow">
          <div className="container-fluid container">
            <div className="row start-md center-xs">
              <div className="col-md-4 col-sm-12">
                <div
                  className="footLogo"
                  onClick={() => (window.location.href = "/")}
                >
                  <a href="/" title="SHELL Fleet Solutions">
                    SHELL Fleet Solutions
                  </a>
                  <span className="footLogoText">Shell Fleet Solutions</span>
                </div>
                <div className="footText">
                  Shell Taşıt Tanıma Sistemi ile <br />
                  filonuzu kolayca yönetin.
                </div>
              </div>

              <div className="col-md-8 col-sm-12">
                <div className="row">
                  <ul className="col-xm-3 col-xs-12 menu bigText">
                    <li className="top">
                      <span>GEZİNTİ</span>
                    </li>

                    <li>
                      <a
                        href="/urunler/shell-tasit-tanima-sistemi"
                        title="Shell Taşıt Tanıma"
                      >
                        Shell Taşıt Tanıma
                      </a>
                    </li>

                    <li>
                      <a href="/urunler" title="Ürünler">
                        Ürünler
                      </a>
                    </li>

                    <li>
                      <a href="/nasil-calisir" title="Nasıl Çalışır">
                        Nasıl Çalışır
                      </a>
                    </li>

                    <li>
                      <a href="/avantajlar" title="Avantajlar">
                        Avantajlar
                      </a>
                    </li>
                  </ul>

                  <ul className="col-xm-3 col-xs-12 menu bigText">
                    <li className="top">
                      <span>ÜRÜNLER</span>
                    </li>

                    <li>
                      <a
                        href="/urunler/shell-tasit-tanima-sistemi"
                        title="Shell Taşıt Tanıma Sistemi"
                      >
                        Shell Taşıt Tanıma Sistemi
                      </a>
                    </li>

                    <li>
                      <a
                        href="/urunler/shell-pratik-kart"
                        title="Shell Pratik Kart"
                      >
                        Shell Pratik Kart
                      </a>
                    </li>

                    <li>
                      <a
                        href="/urunler/shell-partner-card"
                        title="Shell Partner Card"
                      >
                        Shell Partner Card
                      </a>
                    </li>

                    <li>
                      <a
                        href="/urunler/arac-takip-sistemi"
                        title="Araç Takip Sistemi"
                      >
                        Araç Takip Sistemi
                      </a>
                    </li>

                    <li>
                      <a
                        href="/urunler/hizli-gecis-sistemi-hgs"
                        title="Hızlı Geçiş Sistemi (HGS)"
                      >
                        Hızlı Geçiş Sistemi (HGS)
                      </a>
                    </li>

                    <li>
                      <a
                        href="/urunler/kredi-karti-ile-shell-tasit-tanima"
                        title="Kredi Kartı İle Shell TTS"
                      >
                        Kredi Kartı İle Shell TTS
                      </a>
                    </li>
                  </ul>
                  <ul className="col-xm-3 col-xs-12 menu bigText">
                    <li className="top">
                      <span>UTTS</span>
                    </li>
                    <li>
                      <a
                        href="/portal/utts-montaj-basvuru"
                        title="Shell Taşıt Tanıma"
                      >
                        UTTS Montaj Başvur
                      </a>
                    </li>
                    <li>
                      <a
                        href="/portal/utts-kayit-sureci"
                        title="Shell Taşıt Tanıma"
                      >
                        UTTS Kayıt Süreci
                      </a>
                    </li>

                    <li>
                      <a
                        href={`${process.env.REACT_APP_BACKEND_URL}/uploads/yetki-belgesi.pdf`}
                        target="_blank"
                        title="`Yetki Belgesi`"
                      >
                        Yetki Belgesi
                      </a>
                    </li>
                    <li>
                      <a href="/portal/reference/login" title="Referans girişi">
                        Referans Girişi
                      </a>
                    </li>
                    <li>
                      <a href="/portal/admin/login" title="Bayi Portal Girişi">
                        Bayi Portal Girişi
                      </a>
                    </li>
                  </ul>
                  <ul className="col-xm-3 col-xs-12 menu">
                    <li className="top">
                      <span>BİZE ULAŞIN</span>
                    </li>

                    <li>
                      <a href="/iletisim" title="İLETİŞİM">
                        İLETİŞİM
                      </a>
                    </li>

                    <li>
                      <a href="tel:+908502198559" title="Telefon Et">
                        0850 219 8559
                      </a>
                    </li>

                    <li>
                      <a href="mailto:info@kit-tak.com" title="Mail Gönder">
                        info@kit-tak.com
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://maps.app.goo.gl/wsiHDmxVoKmAzQvQ6"
                        target="_blank"
                        title="Adres"
                      >
                        Yakuplu, Kavaklı Cd. Mermerciler Sanayi Sitesi D:16.ca
                        D:3, 34524 Beylikdüzü/İstanbul
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!--/middle--> */}

        {/* <!--middle--> */}

        <div className="container-fluid bottomRow">
          <div className="container-fluid container">
            <div className="row middle-xs start-sm center-xs">
              <div className="col-sm-6 col-xs-12">
                <span className="Copyright">
                  © 2021 Tüm Hakları Saklıdır.
                  <br />
                  Site içeriği başka site ya da medyalar da yayınlanamaz.
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* <!--/middle--> */}
      </div>
    </>
  );
}
